import type { CommonData } from '@/components/blockEditor/blockEditor.types';
import { CURRENT_SCHEMA_VERSION } from '@/components/blockEditor/blockEditor.types';

export function getDefaultIlitOverviewPageTwoData(): CommonData {
  return {
    version: CURRENT_SCHEMA_VERSION,
    blocks: [
      {
        id: 'ilit-overview-page-two-list',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'ilit-overview-page-two-heading',
              type: 'EducationalSlideHeading',
              props: {
                title: 'Is an ILIT right for me?',
                variant: 'h3',
              },
            },
            {
              id: 'ilit-overview-page-two-estate',
              type: 'PresentationListItem',
              props: {
                title: 'Estate size',
                description:
                  'If your estate exceeds or is close to the federal estate tax exemption, an ILIT can provide significant tax benefits.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'ilit-overview-page-two-financial',
              type: 'PresentationListItem',
              props: {
                title: 'Financial situation',
                description:
                  "Since an ILIT is irrevocable, you must be certain you won't need future access to the assets placed in the trust.",
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'ilit-overview-page-two-gift-tax',
              type: 'PresentationListItem',
              props: {
                title: 'Gift tax considerations',
                description:
                  'Transferring existing life insurance policies to an ILIT can trigger gift taxes. Additionally, premiums paid for a policy owned by an ILIT might be considered taxable gifts to the trust beneficiaries.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'ilit-overview-page-two-family',
              type: 'PresentationListItem',
              props: {
                title: 'Family dynamics',
                description:
                  'ILITs can help manage the distribution of your estate, accommodating complex family situations or beneficiaries who may need financial oversight.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'ilit-overview-page-two-guidance',
              type: 'PresentationListItem',
              props: {
                title: 'Professional guidance',
                description:
                  'Consulting with estate planning professionals, including attorneys and financial advisors, is essential to evaluate whether an ILIT aligns with your overall financial strategy.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
          ],
        },
      },
    ],
  };
}
